export function isDemo() {
    // return window.location.href.includes('localhost') || window.location.href.includes('demo.outlawpractice.com');
    return window.location.href.includes('demo.outlawpractice.com');
}